module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tickets-table', {
    attrs: {
      "status": _vm.status,
      "priority": _vm.priority,
      "title-heading": "h2",
      "owner-id": _vm.ownerId,
      "bottom-comp": _vm.bComp,
      "bottom-comp-props": _vm.bCompProps
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f69219ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/maintenance/MaintenanceView.vue
// module id = 1741
// module chunks = 0